import { render, staticRenderFns } from "./v3.vue?vue&type=template&id=67b0558b&scoped=true&"
import script from "./v3.vue?vue&type=script&lang=js&"
export * from "./v3.vue?vue&type=script&lang=js&"
import style0 from "./v3.vue?vue&type=style&index=0&id=67b0558b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b0558b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67b0558b')) {
      api.createRecord('67b0558b', component.options)
    } else {
      api.reload('67b0558b', component.options)
    }
    module.hot.accept("./v3.vue?vue&type=template&id=67b0558b&scoped=true&", function () {
      api.rerender('67b0558b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin-dashboard/v3.vue"
export default component.exports